<template minapp='mpx' xlang='wxml'>
  <view class="order-head" wx:class="{{{ 'scrambling':isBeforeScrambled  }}}">
    <view class="order-head-info">
      <!-- 占座中换新UI -->
      <block>
        <view class="order-head-image">
          <image class="image" src="{{stateImage}}" mode="heightFix"/>
        </view>
      </block>
      <!-- 标题 & 副标题 -->
      <view class="order-head-info-text" wx:class="{{stateTextWrapClass}}">
        <view wx:class="{{ stateTextClass.title }}">
          <view>{{ stateText.title }}</view>
          <view wx:if="{{showAnimate}}" class="prog-num">{{ parseInt(progress * 100)}}%</view>
        </view>
        <view wx:if="{{showAnimate}}" class="prog-wrap">
          <view wx:ref="progref" class="prog-bg"></view>
          <view class="prog" wx:style="{{progStyle}}" ></view>
        </view>
        <view wx:class="{{ stateTextClass.subTitle }}"><text 
          wx:for="{{subTitleTexts}}"
          wx:class="{{ {highlight:item.highlight} }}"
        >{{item.value}}</text></view>
      </view>
    </view>
    <!-- 公告提示条 -->
    <view
      class="notice-tip-content"
      wx:if="{{!this.occupying && serviceNoticeList && serviceNoticeList.length}}"
    >
      <notice-tip
        class="notice"
        wx:for="{{serviceNoticeList}}"
        wx:key="index"
        titleText="{{item.title}}"
        noticeTitle="{{item.noticeTitle}}"
        type="order"
        bindclick="showNoticeTipsPop(index)"
      />
    </view>
  </view>
</template>

<script>
  import { createComponent } from '@didi/es-mpx-creator'
  import store from '@/store'
  import { OrderStatus } from '@/common/enum'
  import { innerRouter, pagePath } from "@/common/jump";
  import { parseDate, compare } from '@/utils/baseDate'
  import { filterHighlightText } from '@/common/public'

  createComponent({
    props: {
      percentage: '',
      remainingTime: undefined,
      serviceNoticeList: [],
      from: String,
      iconName: String,
      title: String,
      subTitle: String,
      occupyConsultTime: {
        type: Number,
        value: -1
      },
      isChange: Boolean
    },
    data() {
      return {
        circle: 'https://ut-static.udache.com/webx/sfc/TKY2OWPdRrZ-13fAJoPQ8.png',
        lightning: 'https://ut-static.udache.com/webx/sfc/PEim2oI0V9bReQIV8361J.png',
        progress: 0,
        progressList: [{
            progress: 0.6,
            time: 5000
          },{
            progress: 0.7,
            time: 10000
          },{
            progress: 0.8,
            time: 20000
          },{
            progress: 0.95,
            time: 30000
          }],
        progressListIndex:  0,
        width: 0,
      }
    },
    computed: {
      ...store.mapState({
        baseInfo: 'order.base_info', // 订单ID
        order_list: 'order.order_list', // 订单ID
        state: 'order.base_info.status', // 订单状态
        tip: 'order.base_info.tip'
      }),
      progStyle(){
        return `width: ${this.progress*this.width}px;transition: 1s`
      },
      isOccupyingSeat() {
        return this.state === OrderStatus.OCCUPYING_SEAT
      },
      isBooking() {
        return this.state === OrderStatus.BOOKING
      },
      isIssuing() {
        return this.state === OrderStatus.ISSUING || this.state === OrderStatus.PAID
      },
      stateImage(){
        if(this.state === OrderStatus.OCCUPYING_SEAT || this.state === OrderStatus.CHANGE_OCCUPYING_SEAT) {
          return 'https://ut-static.udache.com/webx/sfc/rNwSKr_hB_CKxXt8PRaxR_icon1-1.gif'
        }
        else if(this.baseInfo.status_name === '改签中' || this.baseInfo.status_name === '已改签') {
          return 'https://ut-static.udache.com/webx/sfc/Tb2tiCeWH-uALTd6KYxm2.png'
        }
        else if(this.baseInfo.status_name === '已退票' || this.baseInfo.status_name === '退票中') {
          return 'https://ut-static.udache.com/webx/sfc/sTQR9NJJHkHD0RZONIUyl.png'
        }
        else if(this.state === OrderStatus.ISSUING || this.state === OrderStatus.PAID) {
          return 'https://ut-static.udache.com/webx/sfc/Bl7Xj6UZrEOt0BBeecJty_icon3-3.gif'
        }
        else if(this.state === OrderStatus.BOOKING || this.state === OrderStatus.SCRAMBLE_BOOKING) {
          return 'https://ut-static.udache.com/webx/sfc/tkHJnGqaLopUsntFWEm5K_icon2-2.gif'
        }
        else if(this.state === OrderStatus.REISSUE || (this.state === OrderStatus.CLOSED && !this.baseInfo.status_name.includes('失败'))) {
          return 'https://ut-static.udache.com/webx/sfc/8UWaHK74nislAWBw_T_rj_icon6-6.gif'
        }
        else if(this.state === OrderStatus.SCRAMBLE_FAILURE || this.state === OrderStatus.REFUNDING || this.state === OrderStatus.CLOSED ){
          return 'https://ut-static.udache.com/webx/sfc/8qHwpJ-sjeYqebu7K2nZr_icon5-5.gif'
        }
        else if(this.state === OrderStatus.ISSUED){
          return 'https://ut-static.udache.com/webx/sfc/tfg3ihA7KiVeQTQI_1sv7_icon4-4.gif'
        }
        else return 'https://ut-static.udache.com/webx/sfc/f1882R5XR0jsahKgg-66N.png'
      },
      stateTextWrapClass(){
        return {
          'order-state-detail': true,
          'scrambling': this.scrambling,
        }
      },
      stateTextClass() {
        return {
          title: {
            'order-state-name': true,
          },
          subTitle: {
            'order-state-detail': true,
            'scrambling': this.scrambling,
          }
        }
      },
      // subTitle支持\n换行 {{}}包裹高亮
      stateText() {
        const _title = this.title || this.baseInfo.status_name

        // 前端subTitle参数优先级高于后端tip 占座失败tip后端优先级高
        let _tip = this.subTitle || this.tip
        // 免登购票，可以取消订单
        if(this.state === OrderStatus.PAID && this.baseInfo?.order_type === 1) {
          _tip = '已安排专人为您查询余票并占座，请稍等片刻'
        }
        // 免登购票，锁定坐席不可取消
        if(this.state === OrderStatus.ISSUING && this.baseInfo?.order_type === 1) {
          _tip = '出票成功后，会通过短信通知您'
        }
        // 占座失败 已预付款
        if(this.OccupationFailure && this.baseInfo?.is_pay === 1) {
          _tip = this.tip || '预付的款项已原路退回'
        }
        // 待支付 倒计时
        if(this.state === OrderStatus.BOOKING && this.getRemainingTime) {
          const _isExemption = this.baseInfo.order_type === 1
          const _prefix = _isExemption ? '' : '占座成功，'
          _tip = `${_prefix}请在{{${this.getRemainingTime}}}内完成支付`
        }
        // 抢票订单待支付
        if(this.state === OrderStatus.SCRAMBLE_BOOKING && this.getRemainingTime) {
          _tip = `请在{{${this.getRemainingTime}}}内完成支付，支付成功后为您抢票滴滴承诺抢不到票全额退还票价`
        }
        // 占座中
        if(this.state === OrderStatus.OCCUPYING_SEAT){
          _tip = '出票成功后我们会以短信的形式通知您'
        }
        if(this.state === OrderStatus.ISSUING){
          _tip = '出票成功后将短信告知您，锁定状态中，不可取消'
        }
        if(this.occupying && this.getRemainingTime) {
          _tip = `正在排队占座中，预计{{${this.getRemainingTime}}}${this.occupyingText}`
        }
        return {
          title: _title,
          subTitle: _tip
        }
      },
      subTitleTexts() {
        return filterHighlightText(this.stateText.subTitle)
      },
      showAnimate(){
        return [OrderStatus.OCCUPYING_SEAT].includes(this.state) && this.baseInfo.order_type === 0
      },
      //占座中
      occupying() {
        return [23].includes(this.state)
      },
      scrambling(){
        return [OrderStatus.SCRAMBLING].includes(this.state) && this.baseInfo.order_type === 2
      },
      // 占座状态的文案
      occupyingText() {
        return this.baseInfo?.is_pay === 1 ? '占座成功后会立即出票并发送出票成功短信' : '占座成功后将短信通知您支付车票费用'
      },
      // 占座相关，占座中，占座成功
      occupy(){
        return [OrderStatus.OCCUPYING_SEAT,OrderStatus.ISSUING].includes(this.state) && this.baseInfo.order_type === 0
      },
      // 占座失败
      OccupationFailure() {
        return this.state === OrderStatus.REFUNDING  
      },
      // 抢票失败
      scrambleFailure() {
        return this.state === OrderStatus.SCRAMBLE_FAILURE
      },
      esIconName() {
        if([OrderStatus.SCRAMBLING].includes(this.state)){
          return ''
        }
        if(this.iconName) {
          return this.iconName
        }
        // 2 - 待制度
        // 3 - 待审批
        // 5 - 占座失败
        // 8 - 改签中
        // 10 - 退票中
        // 21 - 占座中
        // 22 - 出票中
        // 23 - 改签占座中
        // 33 - 待出票
        return [2, 3, 8, 10, 21, 22, 23, 33, OrderStatus.SCRAMBLE_BOOKING].includes(this.state) 
          ? 'time' 
          : (this.OccupationFailure || this.scrambleFailure)
            ? 'exclamation-circle'
            : 'check-circle'
      },
      getRemainingTime() {
        if(this.baseInfo?.is_pay === 1 && (this.state === OrderStatus.BOOKING || this.state === OrderStatus.SCRAMBLE_BOOKING)) {
          return ''
        }
        if (this.remainingTime) {
          const min = parseInt(this.remainingTime / 60)
          const second = this.remainingTime - min * 60
          return `${min}分${second}秒`
        } else if (this.remainingTime === 0) {
          return '0秒'
        } else {
          return ''
        }
      },
      isBeforeScrambled(){
        return this.baseInfo.order_type === 2 && (
          [ OrderStatus.SCRAMBLE_BOOKING, 
            OrderStatus.SCRAMBLING, 
            OrderStatus.SCRAMBLE_FAILURE,
            OrderStatus.REFUNDING,
            OrderStatus.CLOSED,
            OrderStatus.SCRAMBLE_CANCELLING,
            OrderStatus.REISSUE].includes(this.state)
        )
      },
    },
    created() {
      if(this.occupyConsultTime >= 0) {
        const temp = (300 - this.occupyConsultTime) * 1000
        this.progressList.forEach((item, idx) => {
          const {
            progress,
            time
          } = item
          if(temp >= time) {
            this.progress = progress
            this.progressListIndex = idx-1
          }
        })
        this.startAnimation()
      }
    },
    mounted() {
      this.width = this.$refs.progref?._selector?.clientWidth || 0
    },
    methods: {
      ...store.mapMutations({
        setTravelDate: 'travel.setTravelDate',
        changeSelectCityList: 'travel.changeSelectCityList',
      }),
      // 点击提示条
      showNoticeTipsPop(index) {
        this.triggerEvent('clickIndex', index)
      },
      startAnimation() {
        const _currrentIndex = this.progressListIndex
        if( _currrentIndex + 1 > this.progressList.length) return 
        const _preTime = _currrentIndex === 0 ? 0 : this.progressList[_currrentIndex-1].time
        const _preProg = _currrentIndex === 0 ? 0 : this.progressList[_currrentIndex-1].progress
        const _currrentTime = this.progressList[_currrentIndex].time
        const _currrentProg = this.progressList[_currrentIndex].progress
        const _timeInterval = _currrentTime - _preTime
        const _progInterval = _currrentProg - _preProg
        const _setTimeInterval = parseInt(_timeInterval/(_progInterval * 100))
        const timer = setInterval(() => {
          if (this.progress >= _currrentProg) {
            clearInterval(timer)
            this.progressListIndex = _currrentIndex + 1
            return this.startAnimation()
          }
          const _p = this.progress
          this.progress = _p + 0.01
        }, _setTimeInterval)
      },
    },
  })
</script>
<style scoped lang="stylus">
  @import '~@/mixins/stylus/color.styl'

  .order-head
    padding 16px 12px
    color #ffffff
    background $train-color-theme-blue
    padding 0 10px 10px 10px
    background #FFFFFF
    .circle-wrap
      margin-right 8px
      .circle-inner
        position relative
        display flex
      @keyframes turn
        0%
          transform rotate(0deg)
        100%
          transform rotate(360deg)
      .circle
        width 46px
        height 46px
        flex 1
        animation turn 1.2s linear infinite
      .lightning
        width 16px
        height 16px
        position absolute
        top 50%
        left 50%
        transform translate(-50%,-50%)
    &.scrambling
      background none
      padding-top 2px
    .order-head-info
      display flex
      .order-head-image
        margin-right 10px
        width 74px
        height 74px
        .image 
          height 74px
      .order-head-info-icon
        font-size 24px
        line-height 24px
        margin-right 4px
      .order-head-info-text
        color #ffffff
        flex 1
        padding-right 20px
        justify-content center
        display flex
        flex-direction column
        .prog-wrap
          position relative
          margin-top 10px
          .prog-bg
            height: 10px;
            border-radius: 5px;
            background: #E4EAEF;
          .prog
            position absolute
            top 0
            left 0
            width 0px
            height 10px
            border-radius 5px
            background #FF6400
        .order-state-name
          display flex
          justify-content space-between
          color #000000
          font-weight 500
          font-size 22px
          line-height 22px
          font-family PingFangSC-Medium
        .order-state-detail
          white-space pre-wrap
          font-family PingFangSC-Regular
          line-height 17px
          font-weight normal
          font-size 12px
          color #666666
          margin-top 8px
          padding-right 0
          .highlight
            color #FF6F2A
            font-family PingFangSC-Semibold
      .prog-num
        font-family: Barlow Semi Condensed;
        font-size: 22px;
        font-weight: normal;
        line-height: 22px;
        color: #FF6400;
    .notice-tip-content
      display flex
      flex-direction column
      margin-top 10px
    .notice
      margin-top 1px
</style>
<script name='json'>
  module.exports = {
    component: true,
    usingComponents: {
      'notice-tip': '@/material/block/notice/noticeTip'
    }
  }
</script>